module.exports = __webpack_public_path__ + "img/edai-logo.14f243fe.svg";